"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class DuckChargeAdmin extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'duckChargeAdmin';
        this._kpis = initParams.kpis;
        this._users = (0, util_1.camelArray)(initParams.users);
        this._sessions = (0, util_1.camelArray)(initParams.sessions);
        this._chargePoints = (0, util_1.camelArray)(initParams.charge_points);
        this._totalSessions = initParams.total_sessions;
        this._averageSessionsPerDay = initParams.average_sessions_per_day;
    }
    set kpis(value) {
        console.error('Do not set objects this way');
    }
    get kpis() {
        return this._kpis;
    }
    set users(value) {
        console.error('Do not set objects this way');
    }
    get users() {
        return this._users;
    }
    set sessions(value) {
        console.error('Do not set objects this way');
    }
    get sessions() {
        return this._sessions;
    }
    set chargePoints(value) {
        console.error('Do not set objects this way');
    }
    get chargePoints() {
        return this._chargePoints;
    }
    set totalSessions(value) {
        console.error('Do not set objects this way');
    }
    get totalSessions() {
        return this._totalSessions;
    }
    set averageSessionsPerDay(value) {
        console.error('Do not set objects this way');
    }
    get averageSessionsPerDay() {
        return this._averageSessionsPerDay;
    }
}
exports.default = DuckChargeAdmin;
//# sourceMappingURL=duckChargeAdmin.js.map